<template>
  <div
    :style="{ width: width + 'px', height: height + 'px' }"
    class="video-default-thumbnail"
  >
    <v-icon class="icon">play_arrow</v-icon>
  </div>
</template>

<script>

import CalcHeightMixin from '@/mixins/CalcHeightMixin';

export default {
  name: 'VideoDefaultThumbnail',
  mixins: [CalcHeightMixin],
  props: {
    width: {
      default: 200,
    },
  },
};

</script>

<style scoped>

.video-default-thumbnail {
  /*width: 170px;*/
  /*height: 96px;*/
  border: dashed 2px rgba(0,0,0, .4);
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon {
  font-size: 60px;
}

</style>



// WEBPACK FOOTER //
// src/components/VideoDefaultThumbnail.vue